import React from "react";

export default function TratamientoBanner({
  entry,
  entradasConRecordatorios,
  tieneMedicamentosTratables,
  isVetAccess,
  onVerDashboard,
  onStartTratamiento
}) {
  if (entry.isNew || entry.anulado || isVetAccess || !tieneMedicamentosTratables(entry)) {
    return null;
  }

  const tratamiento = entradasConRecordatorios[entry.id];

  if (tratamiento) {
    return (
      <div
        onClick={() => onVerDashboard(tratamiento.tratamientoId)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '10px 14px',
          marginBottom: '12px',
          backgroundColor: '#fef3c7',
          border: '1px solid #fcd34d',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
      >
        <span style={{ fontSize: '18px' }}>💊</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '13px', fontWeight: '600', color: '#92400e' }}>
            Tratamiento activo — Día {tratamiento.diaActual}/{tratamiento.diasTotales}
            {tratamiento.racha > 0 && ` • 🔥 ${tratamiento.racha} días`}
          </div>
        </div>
        <span style={{ color: '#92400e', fontSize: '12px', fontWeight: '500' }}>Ver progreso &rarr;</span>
      </div>
    );
  }

  return (
    <div
      onClick={() => onStartTratamiento(entry)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 14px',
        marginBottom: '12px',
        backgroundColor: '#eff6ff',
        border: '1px solid #bfdbfe',
        borderRadius: '8px',
        cursor: 'pointer'
      }}
    >
      <span style={{ fontSize: '18px' }}>🔔</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '13px', fontWeight: '600', color: '#1d4ed8' }}>
          Iniciar plan de tratamiento
        </div>
        <div style={{ fontSize: '12px', color: '#3b82f6' }}>
          Activa recordatorios para no olvidar ninguna toma
        </div>
      </div>
      <span style={{ color: '#1d4ed8', fontSize: '16px' }}>&rarr;</span>
    </div>
  );
}
